import { useState } from 'react';
import type { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { NgButton } from '@/ui';
import { useEditForm } from '@/ui/forms/useEditForm';

export type CheckListSearchComponentProps = {
  onSearch: (text: string | null) => void;
};

export function CheckListSearchComponent({ onSearch }: CheckListSearchComponentProps) {
  const { t } = useTranslation();
  const [searchString, setSearchString] = useState<string | null>(null);
  const editForm = useEditForm<'searchString'>({ initialBaselineValues: { searchString: '' } });

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    editForm.validate(() => ({}));
    onSearch(searchString);
  };

  return (
    <form onSubmit={handleSearch}>
      <div className="d-flex justify-content-center bg-dark-subtle p-2">
        <div className="input-group" style={{ maxWidth: '300px' }}>
          <input
            className={editForm.fieldCssClass('searchString', 'form-control border-dark')}
            value={searchString ?? ''}
            onChange={(event) => {
              setSearchString(event.target.value);
              editForm.notifyFieldInput('searchString', event.target.value);
            }}
            onBlur={() => editForm.notifyFieldBlur('searchString')}
            placeholder={t('Placeholder_Search')}
          />
          <NgButton icon="fal fa-search" submitButton />
        </div>
      </div>
    </form>
  );
}
